import { useEffect, useRef } from "react";

/**
 * Textarea que crece automáticamente con el contenido (no scroll interno).
 *
 * Uso idéntico a un `<textarea>` estándar. `rows` se interpreta como ALTURA
 * MÍNIMA inicial. Cualquier prop adicional (className, placeholder, data-testid,
 * onChange, onFocus…) se reenvía al elemento real.
 *
 * Implementación: en cada cambio de `value`, fija `height: auto` para medir el
 * `scrollHeight` real y lo aplica como altura efectiva. No re-monta el nodo, así
 * el cursor del usuario no se mueve.
 */
export default function AutoTextarea({ value, className = "", style, ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value ?? ""}
      // resize-none porque ya nos hacemos cargo de la altura nosotros mismos.
      className={`${className} resize-none overflow-hidden`}
      style={style}
      {...rest}
    />
  );
}
